import { Message } from '../message.model';

export interface CountByHourData {
  Acceso: string;
  'Conversión Ingreso': number | string;
  'Conversión Salida': number | string;
  Consolidado: string;
  Entradas: number | string;
  Salidas: number | string;
  Fecha: string;
  Hora: string;
  Día: string;
  Mes: string;
  Factor?: number | string;
}

export interface CountByHourCameraResponse {
  'public data': CountByHourData[] | Message;
}
export interface CountByHourAccessResponse {
  'public data2': CountByHourData[] | CountByHourAccessMessage;
}

export interface CountByHourAccessMessage {
  column_name: ColumnName;
}

export interface ColumnName {
  message: string;
  parametros: Parameters;
}

export interface Parameters {
  'fecha inicial': string;
  'fecha final': string;
  oficina: number;
}

export interface CountByHourRequest {
  sucursal: string;
}
